// extracted by mini-css-extract-plugin
export default {"highlighted":"TickerPickerGroup_highlighted__TVqjE","check":"TickerPickerGroup_check__wBOym"};